<template>
  <v-container grid-list-xl class="pa-0">
    <template v-slot:default>tes</template>
    <v-form @submit.prevent data-vv-scope="form" lazy-validation>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <m-alert
            show
            color="blue"
            title="Informasi"
            :info="textHint"
          ></m-alert>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12">
          <m-card-list
            two-line
            title="Rekap Riwayat Kehadiran"
            :items="presensi"
            :headers="headers"
            generate
            :textHint="textHint"
            :page="page"
            :idKey="'user_id'"
            footer
            @change:page="
              pg => {
                cp = pg;
                load();
              }
            "
          >
            <template v-slot:items="{ item }">
              <tr v-if="$vuetify.breakpoint.smAndUp">
                <td class="text-left font-weight-bold">{{ pVal(item, "nama") }}</td>
                <td class="text-left">{{ pVal(item, "tanggal") }}</td>
                <td class="text-center">{{ pVal(item, "jumlah_hadir") }}</td>
                <td class="text-center">{{ pVal(item, "kewajiban_hadir") }}</td>
                <td class="text-center">
                  {{ pVal(item, "presentase") | toF2 }}%
                </td>
              </tr>
              <tr v-else>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">Nama</div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "nama") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">
                    Tanggal
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "tanggal") }}x
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">Waktu</div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "waktu") }}x
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">
                    Lokasi
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "waktu") }}x
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">
                    Kategori
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "kategori") }}x
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">
                    Prosentase
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "prosentase") | toF2 }}%
                  </div>
                </td>
              </tr>
            </template>
          </m-card-list>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  data: () => ({
    kehadiran: {},
    textHint: "Data rekap riwayat kehadiran (7 hari terakhir)",
    page: null,
    cp: 1,
    headers: [
      { text: "Nama", align: "left", value: "nama" },
      { text: "Tanggal", align: "left", value: "tanggal" },
      { text: "Jumlah Hadir", align: "left", value: "jumlah_hadir" },
      { text: "Kewajiban Hadir", align: "left", value: "wajib_hadir" },
      { text: "Prosentase", align: "center", value: "prosentase" }
    ]
  }),
  mounted() {
    this.kehadiran.tanggalAwal = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.kehadiran.tanggalAkhir = moment()
      .endOf("month")
      .format("YYYY-MM-DD");
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("riwayatKehadiran/rekap", {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            tgl_awal: this.kehadiran.tanggalAwal,
            tgl_akhir: this.kehadiran.tanggalAkhir
          }
        })
        .then(res => {
          this.page = res.data;
          this.show = true;
          this.presensi = res.data.data;
          this.textHint =
            "Data Rekap Kehadiran mulai <strong>" +
            this.$options.filters.toD(this.kehadiran.tanggalAwal) +
            " s/d " +
            this.$options.filters.toD(this.kehadiran.tanggalAkhir) +
            "</strong>";
        })
        .catch(e => e);
    },
    filter(data) {
      this.cp = 1;
      if (data.dateRange) {
        this.kehadiran.tanggalAwal = data.from;
        this.kehadiran.tanggalAkhir = data.t;
        this.load();
      } else {
        this.kehadiran.tanggalAwal = null;
        this.kehadiran.tanggalAkhir = null;
        this.load();
      }
      this.textHint =
        "Anda menampilkan data Rekap Kehadiran mulai tanggal " +
        this.$options.filters.toD(this.kehadiran.tanggalAwal) +
        " s/d " +
        this.$options.filters.toD(this.kehadiran.tanggalAkhir);
    }
  }
};
</script>
